<script setup lang="ts">
import Footer from './Footer.vue'
import ThemeToggle from './ThemeToggle.vue'
</script>

<template>
    <ThemeToggle />
    <div class="flex flex-col gap-3 px-6 py-12">
        <slot />
    </div>
            <Footer />
</template>
